import { render } from "./articleListe.vue?vue&type=template&id=bff38f6e&scoped=true"
import script from "./articleListe.vue?vue&type=script&lang=js"
export * from "./articleListe.vue?vue&type=script&lang=js"

import "./articleListe.vue?vue&type=style&index=0&id=bff38f6e&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff38f6e"]])

export default __exports__